<template>
    <div class="sidebar">
        <div class="sidebar-top img-wrap" v-html="ad.post_sidebar_top"></div>
        <div class="unique-info">
            <p class="section-title">汇眼独具</p>
            <ul v-if="uniqueShow" class="unique-list">
                <li v-for="item in article['汇眼独具']">
                    <a class="article-title" :href="item.guid" target="_blank">{{item.post_title}}</a>
                    <div class="tags">
                        <span class="icon"></span>
                        <a :href="'http://www.evhui.com/tag/'+tag.name" target="_blank" v-for="(tag, index) in item.tags" v-show="index<3">{{tag.name}}</a>
                    </div>
                    <p class="time">{{item.post_modified | formatTime}}</p>
                </li>
            </ul>
        </div>
        <div class="sidebar-special">
            <p class="section-title">特别策划</p>
            <div class="img-wrap" v-html="ad.index_sidebar_special"></div>
        </div>
        <div class="brand-division">
            <p class="section-title">品牌专区</p>
            <ul v-if="brandShow">
                <li v-for="item in article['比亚迪*上汽*北汽*宝马*戴姆勒']">
                    <a href="#"><img class="brand-icon" :src="icon[item.tags[0].name]" alt="">{{item.tags[0].name}}</a>
                    <a class="article-title" :href="item.guid" target="_blank">{{item.post_title}}</a>
                </li>
            </ul>
        </div>
        <div class="img-wrap" v-html="ad.post_sidebar_center"></div>
        <div class="hot">
            <div class="nav-wrap">
                <ul class="nav">
                    <li v-bind:class="{on: isPopular}" @click="getHot('popular')">热门文章</li>
                    <li v-bind:class="{on: !isPopular}" @click="getHot('comment')">热门评论</li>
                </ul>
            </div>
            <div class="hot-content">
                <ul>
                    <li v-for="item in hot">
                        <span></span>
                        <a href="http://www.evhui.com/category/info" target="_blank" class="category">{{item.category[0].name}}</a>
                        <a :href="item.guid" target="_blank" class="title">{{item.post_title}}</a>
                        <div class="tags">
                            <span class="icon"></span>
                            <a :href="'http://www.evhui.com/tag/'+tag.name" target="_blank" v-for="tag in item.tags">{{tag.name}}</a>
                        </div>
                        <p class="time">{{item.post_modified | formatTime}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="link-wrpa">
            <div class="title-wrap">
                <span class="section-title left-title">友情链接</span>
            </div>
            <ul class="link-list">
                <li v-for="link in links">
                    <a :href="link.link" target="_blank">{{link.name}}</a>
                </li>
            </ul>
        </div>
        <div class="partner">
            <div class="title-wrap">
                <span class="section-title left-title">合作伙伴</span>
            </div>
            <ul class="partner-list">
                <li><a href="http://www.idccun.com/" target="_blank">互联港湾</a></li>
                <li><a href="http://www.dnspod.cn/" target="_blank">DNSPod</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Side from './Side'
    import axios from 'axios'
    export default {
        components: {
            Side
        },
        props: ["ad"],
        data() {
            return {
                article: {},
                uniqueShow: false,
                brandShow: false,
                links: [],
                hot: {},
                popular: {},
                comment: {},
                isPopular: true,
                icon: {
                    '宝马': 'http://image.evhui.com/brand_icon_30px/38682f.jpg',
                    '上汽': 'http://image.evhui.com/brand_icon_30px/023fb0.jpg',
                    '比亚迪': 'http://image.evhui.com/brand_icon_30px/1de9a5.jpg',
                    '北汽': 'http://image.evhui.com/brand_icon_30px/9aae58.jpg'
                }
            }
        },
        filters: {
            formatTime: (time) => {
                var timeArr = time.split(' ')[0].split('-');
                return timeArr[1]+'月'+timeArr[2]+'日';
            }
        },
        mounted() {
            this.$nextTick(function() {
                let that = this;
                that.getArticle('汇眼独具', 3, function(){
                    that.uniqueShow = true;
                });
                that.getArticle('比亚迪*上汽*北汽*宝马*戴姆勒', 2, function(){
                    that.brandShow = true;
                });
                that.getLinks();
                that.getPopular();
                that.getComment();
            });
        },
        methods: {
            getData(obj, callback) {
                axios.get(obj).then((res) => {
                    callback(res);
                }).catch((err) => {
                    console.log(err);
                });
            },
            getArticle(tag, limit, callback) {
                let that = this;
                that.getData('/api/blog/tag/'+tag+'?limit='+limit, (res) => {
                    that.article[tag] = res.data.data;
                    callback();
                });
            },
            getLinks() {
                let that = this;
                that.getData('/api/blog/link', (res) => {
                    that.links = res.data.data;
                });
            },
            getPopular() {
                let that = this;
                that.getData('/api/blog/popular?limit=3&order=desc', (res) => {
                    that.hot = res.data.data;
                    that.popular = res.data.data;
                });
            },
            getComment() {
                let that = this;
                that.getData('/api/blog/comment?limit=3&order=desc', (res) => {
                    that.comment = res.data.data;
                });
            },
            getHot(str) {
                let that = this;
                if(str === 'popular') {
                    that.hot = that.popular;
                    that.isPopular = true;
                }else {
                    that.hot = that.comment;
                    that.isPopular = false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .sidebar {
        float: right;
        width: 260px;
        margin-bottom: 100px;
        background-color: #fff;
        .section-title {
            width: 100%;
            height: 50px;
            border-bottom: 2px solid $maincolor;
            text-align: center;
            line-height: 50px;
            font-size: 20px;
            color: #898989;
        }
        .left-title {
            position: absolute;
            left: 0;
            bottom: -1px;
            width: 99px;
            height: 100%;
        }
    }
    .unique-list {
        li {
            display: block;
            margin: 10px 10px 10px;
            padding-bottom: 10px;
            &:not(:last-child) {
                border-bottom: 1px dashed #999;
            }
        }
        .article-title {
            width: 240px;
            overflow: hidden;
            font-size: 16px;
            line-height: 30px;
            color: #333;
            &:hover {
                color: $maincolor;
            }
        }
    }
    .img-wrap {
        padding: 20px 10px;
    }
    .title-wrap {
        position: relative;
        height: 40px;
        text-align: left;
        border-bottom: 1px solid #999;
        background: #fff;
    }
    .hot {
        .nav-wrap {
            position: relative;
            height: 35px;
            border-bottom: 1px solid #C6C6C6;
        }
        .nav {
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 260px;
            overflow: hidden;
            margin: 0 auto;
            li {
                float: left;
                width: 108px;
                height: 35px;
                line-height: 35px;
                margin-bottom: -1px;
                text-align: center;
                border: 1px solid #c6c6c6;
                border-bottom: none;
                background: #D7D7D7;
                color: #666;
                cursor: pointer;
                &:first-child {
                    border-right: none;
                    margin-left: 20px;
                }
            }
            .on {
                height: 35px;
                background: #fff;
                border-bottom: 1px solid transparent;
            }
        }
    }

    .tags {
        margin: 5px 0;
        .icon {
            float: left;
            width: 20px;
            height: 30px;
            background-position: -405px -907px;
            background-image: url(http://www.evhui.com/wp-content/themes/evhui3.0/public/images/icon.png);
            background-repeat: no-repeat;
        }
        a {
            display: inline-block;
            padding-left: 10px;
            color: #999;
            font-size: 12px;
            line-height: 25px;
            &:hover {
                color: $maincolor;
            }
        }
    }
    .time {
        color: #999;
        font-size: 12px;
        line-height: 25px;
    }
    .hot-content {
        li {
            margin: 10px 10px 10px;
            padding-bottom: 10px;
            &:not(:last-child) {
                border-bottom: 1px dashed #999;
            }
            &>span {
                display: inline-block;
                width: 30px;
                height: 30px;
                margin-right: 10px;
                background-position: -401px -710px;
                background-image: url(http://www.evhui.com/wp-content/themes/evhui3.0/public/images/icon.png);
                background-repeat: no-repeat;
                vertical-align: middle;
            }
        }
        .category {
            font-size: 14px;
            line-height: 30px;
            color: #333;
            &:hover {
                color: $maincolor;
            }
        }
        .title {
            display: inline-block;
            color: #333;
            font-size: 16px;
            line-height: 30px;
            &:hover {
                color: $maincolor;
            }
        }
    }
    .partner-list,
    .link-list {
        padding: 15px 10px;
        li {
            display: inline-block;
        }
        a {
            display: inline-block;
            color: #333;
            font-size: 12px;
            line-height: 25px;
            padding: 0 5px;
            margin: 5px 0 0 4px;
            background: #f2f2f2;
            text-decoration: none;
            &:hover {
                color: $maincolor;
            }
        }
    }
    .brand-division {
        li {
            margin: 10px 10px 10px;
            padding-bottom: 10px;
            &:not(:last-child) {
                border-bottom: 1px dashed #999;
            }
        }
        a {
            display: inline-block;
            color: #333;
            font-size: 14px;
            line-height: 25px;
            &:hover {
                color: $maincolor;
            }
        }
    }
    .brand-icon {
        margin-right: 10px;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// Side.vue?0555b13c